import getConfig from 'next/config';

const { serverRuntimeConfig } = getConfig();

export const {
  APPCUES_ACCOUNT_ID,
  APPCUES_SECRET,
  APPCUES_API_KEY,
  KICKBOX_URL,
  VERIFY_MAIL_URL,
  VERIFY_MAIL_KEY,
  LD_SDK_KEY,
  LD_API_KEY,
  LD_API_URL,
  UNLEASH_API_KEY,
  RECAPTCHA_SITE_KEY,
  RECAPTCHA_BYPASS_KEY,
  GCP_PROJECT_ID,
  GCLOUD_API_KEY,
  REGION,
  SEGMENT_API_KEY,
  SEGMENT_WEBHOOK_SECRET,
  SEGMENT_PERSONA_AUTHORIZATION_KEY,
  SEGMENT_SPACE,
  SAUCE_USERNAME,
  SAUCE_ACCESS_KEY,
  TWILIO_ACCOUNT_SID,
  TWILIO_AUTH_TOKEN,
  TWILIO_SERVICE_SID,
  USER_SERVICE_CLIENT_ID,
  USER_SERVICE_CLIENT_ID_US,
  USER_SERVICE_CLIENT_ID_EU,
  USER_SERVICE_CLIENT_ID_AU,
  USER_SERVICE_CLIENT_NAME,
  USER_SERVICE_URL_US,
  USER_SERVICE_URL_EU,
  USER_SERVICE_K8S_URL,
  IAM_JWT_PUBLIC_KEY,
  USE_FIREBASE,
  USE_FIREBASE_SERVICE_ACCOUNT,
  FIREBASE_PROJECT_ID,
  CORD_APP_ID,
  CORD_APP_SECRET,
  MAXMIND_ACCOUNT_ID,
  MAXMIND_LICENSE_KEY,
  KAFKA_BROKER,
  KAFKA_API_KEY,
  KAFKA_USERNAME,
}: {
  APPCUES_ACCOUNT_ID: string;
  APPCUES_SECRET: string;
  APPCUES_API_KEY: string;
  KICKBOX_URL: string;
  VERIFY_MAIL_URL: string;
  VERIFY_MAIL_KEY: string;
  LD_SDK_KEY: string;
  LD_API_KEY: string;
  LD_API_URL: string;
  UNLEASH_API_KEY: string;
  RECAPTCHA_SITE_KEY: string;
  RECAPTCHA_BYPASS_KEY: string;
  GCP_PROJECT_ID: string;
  GCLOUD_API_KEY: string;
  REGION: string;
  SEGMENT_API_KEY: string;
  SEGMENT_WEBHOOK_SECRET: string;
  SEGMENT_PERSONA_AUTHORIZATION_KEY: string;
  SEGMENT_SPACE: string;
  SAUCE_USERNAME: string;
  SAUCE_ACCESS_KEY: string;
  TWILIO_ACCOUNT_SID: string;
  TWILIO_AUTH_TOKEN: string;
  TWILIO_SERVICE_SID: string;
  USER_SERVICE_CLIENT_ID: string;
  USER_SERVICE_CLIENT_ID_US: string;
  USER_SERVICE_CLIENT_ID_EU: string;
  USER_SERVICE_CLIENT_ID_AU: string;
  USER_SERVICE_CLIENT_NAME: string;
  USER_SERVICE_URL_US: string;
  USER_SERVICE_URL_EU: string;
  USER_SERVICE_K8S_URL: string;
  IAM_JWT_PUBLIC_KEY: string;
  USE_FIREBASE: string;
  USE_FIREBASE_SERVICE_ACCOUNT: string;
  FIREBASE_PROJECT_ID: string;
  CORD_APP_ID: string;
  CORD_APP_SECRET: string;
  MAXMIND_ACCOUNT_ID: string;
  MAXMIND_LICENSE_KEY: string;
  KAFKA_BROKER: string;
  KAFKA_API_KEY: string;
  KAFKA_USERNAME: string;
} = serverRuntimeConfig;
